import { useCallback } from 'react';
import { extractDataFromDOMEvent } from '../utils/extractDataFromDOMEvent';
export var useCommonDatePickerSelectionEvents = function useCommonDatePickerSelectionEvents(_ref) {
  var onDayMouseEnter = _ref.onDayMouseEnter,
    onDayMouseLeave = _ref.onDayMouseLeave;
  var onMouseEnter = useCallback(function (event) {
    if (!onDayMouseEnter) {
      return;
    }
    var data = extractDataFromDOMEvent(event);
    if (!data) {
      return;
    }
    var vector = data.vector;
    onDayMouseEnter(vector.convertToLocalDate());
  }, [onDayMouseEnter]);
  var onMouseLeave = useCallback(function (event) {
    if (!onDayMouseLeave) {
      return;
    }
    var data = extractDataFromDOMEvent(event);
    if (!data) {
      return;
    }
    var vector = data.vector;
    onDayMouseLeave(vector.convertToLocalDate());
  }, [onDayMouseLeave]);
  return {
    dayButtonProps: {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }
  };
};